import { formatDistanceToNow } from 'date-fns';

export function formatRelativeTime(date: string): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
}

export function validateUsername(username: string): string | null {
  if (!username) return 'Username is required';
  if (username.length < 3) return 'Username must be at least 3 characters';
  if (username.length > 20) return 'Username must be 20 characters or less';
  if (!/^[a-zA-Z0-9_]+$/.test(username)) return 'Username can only contain letters, numbers, and underscores';
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  return null;
}

export function validateEmail(email: string): string | null {
  if (!email) return null; // email is optional
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) return 'Invalid email format';
  return null;
}

export function formatNumber(num: number): string {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.toString();
}

// Reddit-style hot score algorithm
export function calculateHotScore(upvotes: number, downvotes: number, createdAt: string): number {
  const score = upvotes - downvotes;
  const order = Math.log10(Math.max(Math.abs(score), 1));
  const sign = score > 0 ? 1 : score < 0 ? -1 : 0;
  const epochSeconds = new Date(createdAt).getTime() / 1000;
  const referenceEpoch = 1704067200; // Jan 1, 2024
  const secondsAge = epochSeconds - referenceEpoch;
  return sign * order + secondsAge / 45000;
}

export function getTagColor(tag: string): { bg: string; text: string; border: string } {
  const colors: Record<string, { bg: string; text: string; border: string }> = {
    'UFOs/UAPs/Aliens': { bg: 'bg-green-900/50', text: 'text-green-300', border: 'border-green-500/30' },
    'Government/Deep State': { bg: 'bg-red-900/50', text: 'text-red-300', border: 'border-red-500/30' },
    'Ancient Civilizations': { bg: 'bg-amber-900/50', text: 'text-amber-300', border: 'border-amber-500/30' },
    'Tech/AI/Surveillance': { bg: 'bg-cyan-900/50', text: 'text-cyan-300', border: 'border-cyan-500/30' },
    'False Flags': { bg: 'bg-orange-900/50', text: 'text-orange-300', border: 'border-orange-500/30' },
    'Occult/Esoteric': { bg: 'bg-purple-900/50', text: 'text-purple-300', border: 'border-purple-500/30' },
    'Alternative Health': { bg: 'bg-lime-900/50', text: 'text-lime-300', border: 'border-lime-500/30' },
    'Hidden History': { bg: 'bg-yellow-900/50', text: 'text-yellow-300', border: 'border-yellow-500/30' },
    'Cryptids/Paranormal': { bg: 'bg-teal-900/50', text: 'text-teal-300', border: 'border-teal-500/30' },
    'Secret Societies': { bg: 'bg-indigo-900/50', text: 'text-indigo-300', border: 'border-indigo-500/30' },
    'Financial/Economic': { bg: 'bg-emerald-900/50', text: 'text-emerald-300', border: 'border-emerald-500/30' },
    'Media Manipulation': { bg: 'bg-rose-900/50', text: 'text-rose-300', border: 'border-rose-500/30' },
  };
  return colors[tag] || { bg: 'bg-gray-900/50', text: 'text-gray-300', border: 'border-gray-500/30' };
}

